import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_CODES_ROME, ENDPOINT_SEARCH} from '@/constants/endpoints'

let store = {
  debug: true,

  get(id) {
    return axios
        .get(ENDPOINT_CODES_ROME + '/' + id)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  getByCodeLibelle(codeLibelle) {
    return axios
        .get(ENDPOINT_CODES_ROME, {params: {codeLibelle}})
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  create(code) {
    return axios
        .post(ENDPOINT_CODES_ROME, code)
        .then((value) => {
          return value.data;
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  update(code, action) {
    return axios
        .put(ENDPOINT_CODES_ROME, code)
        .then((value) => {
          AlertStore.pushSuccess(`Code ROME ${action} avec succès.`);
          return value.data;
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  delete(id) {
    return axios
        .delete(ENDPOINT_CODES_ROME + '/' + id)
        .then(() => {
          AlertStore.pushSuccess('Code ROME supprimé avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  search(code, pageIndex, pageSize, sortOptions) {
    let recherche = [];
    recherche.push({key: 'code', operation: ':', value: code.code});
    recherche.push({key: 'libelle', operation: ':', value: code.libelle});
    recherche.push({key: 'type', operation: '=', value: code.type});
    recherche.push({key: 'poleEmploi', operation: '=', value: code.poleEmploi});
    recherche.push({key: 'verifie', operation: '=', value: code.verifie});
    recherche.push({key: 'customType', operation: '=', value: code.customType});
    recherche.push({key: 'presentSynthese', operation: '=', value: code.presentSynthese});

    let url = `${ENDPOINT_CODES_ROME + ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }

    return axios
        .post(url, recherche);
  },
  updateType(id, type) {
    return axios
        .put(`${ENDPOINT_CODES_ROME}/${id}/changer-type`,  {type})
        .then((value) => {
          return value.data;
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  }

};

export default store;
